import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisDynamicFieldBase } from '../../model/field-base';
import { HisDynamicFieldConfig } from '../../model/formfield';

import { HisBaseGlobalsService } from './../../../core/service/base/his-base-globals.service';
import { HisDynamicFieldConfigAndData } from '../../model/field-config-and-data';

@Component({
    template: `
		<his-plam [label]="options.label" [helptext]="options.helptext">
		    <p-autoComplete #content [formControl]="formControl" [hisDdKey]="options.ddKey" [multiple]="true" [typeahead]="false"
			    [class]="options.disabled ? 'hideInput' : ''" [addOnSeparators]="[',']">
		    </p-autoComplete>
		</his-plam>
    `,
    styleUrls: ['./chips.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChipsComponent extends HisDynamicFieldBase<string> implements OnInit {
    options: HisDynamicFieldConfig;

    constructor() {
        const injectedData = inject<HisDynamicFieldConfigAndData>('injectedData' as any);
        const hbgs = inject(HisBaseGlobalsService);

        super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
        this.options = injectedData.options;
    }

    ngOnInit() {
        super.initFormControl(this.value?.length ? this.value.split(',') : []);
    }

    updateConfiguration(entireFormConfig: HisDynamicFieldConfig) {
        let matchingConfig = this.searchFieldConfig(entireFormConfig);
        if (matchingConfig !== null) {
            this.formControl.setValue(
                matchingConfig.defaultValue?.length ? matchingConfig.defaultValue.split(',') : [], { emitEvent: false }
            );
        }
    }

    getControlValue(): string {
	    const value = this.formControl.value;

	    if (Array.isArray(value)) {
	        return value
	            .map(item => typeof item === 'string' ? item : item?.defaulttext ?? '')
	            .filter(v => !!v)
	            .join(',');
	    }

	    return typeof value === 'string' ? value : '';
    }
}
